import {Component} from '@angular/core';

@Component({
    selector: 'nirby-tutorial-sidebar',
    templateUrl: './tutorial-sidebar.component.html',
    styleUrls: ['./tutorial-sidebar.component.scss'],
})
export class TutorialSidebarComponent {
}
